// Push notifications.
// - Android / iOS app (Capacitor): @capacitor/push-notifications gives an FCM token, which is sent to /v1/push/tokens.
// - Browser: permission only for now; web push needs the Firebase web SDK + a VAPID key (see README › Push).
// In-app notifications (the bell screen) work everywhere without push.
import { api } from './api';

interface PushPlugin {
  requestPermissions(): Promise<{ receive: string }>;
  register(): Promise<void>;
  addListener(event: string, cb: (x: { value?: string; notification?: { data?: { link?: string } } }) => void): Promise<unknown>;
}
type Cap = { isNativePlatform?: () => boolean; getPlatform?: () => string; Plugins?: { PushNotifications?: PushPlugin } };
const cap = () => (window as unknown as { Capacitor?: Cap }).Capacitor;

/** Ask for permission and register this device. Returns 'granted' | 'denied' | 'unsupported'. */
export async function enablePush(): Promise<'granted' | 'denied' | 'unsupported'> {
  const c = cap();
  const plugin = c?.isNativePlatform?.() ? c.Plugins?.PushNotifications : undefined;
  if (plugin) {
    const p = await plugin.requestPermissions();
    if (p.receive !== 'granted') return 'denied';
    await plugin.addListener('registration', (t) => { if (t.value) api.registerPush(t.value, c?.getPlatform?.() === 'ios' ? 'ios' : 'android').catch(() => {}); });
    // Tapping a notification opens its link inside the app.
    await plugin.addListener('pushNotificationActionPerformed', (a) => { const link = a.notification?.data?.link; if (link) location.hash = link; });
    await plugin.register();
    return 'granted';
  }
  if (!('Notification' in window)) return 'unsupported';
  return (await Notification.requestPermission()) === 'granted' ? 'granted' : 'denied';
}
